import { Container, Spinner } from "react-bootstrap"

const Loading = () => {
	return <Container className="text-center p-2">
		<Spinner animation='border' size='lg'/>
	</Container>
}

export default Loading